<div class="container">
    <div class="wrapper">
        <div class="wrapperTop">
            <h3>
                ¿Desea eliminar {{dialogData === 'modelo' ? 'el ' + dialogData : 'la ' + dialogData}}?
            </h3>
        </div>
        <div class="wrapperBottom">
            <button nbButton size="small" class="buttontz reporteBTN" (click)="close('No')">No</button>
            <button nbButton size="small" class="buttontz reporteBTN" (click)="close('Si')">Si</button>
        </div>
    </div>
</div>